import { SUBITEM_FORM_ERRORS } from 'core/constants/navigation.constants';
import { ENavigationFormError } from 'core/model/enums/navigation.enum';
import { THierarchyTreeSubitem } from 'core/model/interfaces/navigation/hierarchy.interface';
import { IServiceErrorContent } from 'core/model/interfaces/service.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { getUnexpectedErrorMessages } from '../../navigation.utils';
import { INavigationState } from '../../types';

export const editNavigationSubitem = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/editNavigationSubitem`,
  async (data: THierarchyTreeSubitem, { rejectWithValue }) => {
    try {
      await apiService.hierarchy.editHierachySubitem(data);
      notificationService.global.success('Submundo editado correctamente.');
    } catch (error) {
      const handledError = handleSpecificErrors(
        error,
        getUnexpectedErrorMessages('subitems', 'edit'),
        SUBITEM_FORM_ERRORS,
      );

      if (handledError) return rejectWithValue(handledError);

      throw error;
    }
  },
);

export const editNavigationSubitemReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(editNavigationSubitem.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(editNavigationSubitem.rejected, (state, action) => {
      state.form.loading = false;
      state.form.success = false;
      const errorContent = action.payload as IServiceErrorContent;
      if (errorContent?.code === ENavigationFormError.productIds) {
        state.form.errors.productIds = errorContent.details.join('\n\n');
      }
    })
    .addCase(editNavigationSubitem.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
